import React, { useEffect, useState, useRef } from 'react';
import { Button, Checkbox, Grid, Image, Input, Header, Popup, Label } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormikContext, Field } from 'formik'; // Import Formik context and Field

import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';

import versionIcon from '../assets/version_icon_simple.svg';
import bookInfoIcon from '../assets/info_icon.svg';
import processingIcon from '../assets/processSqIcon1.gif';

import bookInfoIconRed from '../assets/info_icon_red.svg';
import ingestBookImg from '../assets/shutterstock_2294396055-480x480.jpg';
import processedDataImg from '../assets/processData.png';
import processedDataImgDone from '../assets/robotHoldsBook.svg';
import processedFileIcon from '../assets/processedFileIcon.svg';

import { FileDropzoneOverImg, FileDropzonePdf } from '../utils/fileDropZone';
import { selectClearStory, CustomDropdown, fetchAllBooks, fetchFullBook, fetchUserAndBookStatistics, selectBookListOptions } from '../slices/storyEditorSlice';
import ConfirmButton from '../utils/confirmButton';
import ActiveStory from '../pages/subPages/ActiveStory';
import FillVariations from '../pages/subPages/FillVariations';
import PDFMetadataViewer from './pdfMetaDataViewer';
import {
  selectFullBookTreeData,
  fetchparseDataFromS3,
  selectParsedStoryData, selectFetchparseDataFromS3Status, selectFetchparseDataFromS3Error,
} from '../slices/storyEditorSlice';
import '../index.css';

const formatStoryDataJSON_HTML = (storyData) => {
  if (!Array.isArray(storyData) || storyData.length === 0) return 'No Story Data Found';
  let index = -1;
  let results = (
    <div key={'storyRootDiv'} style={{ height: "500px", overflow: "scroll" }}>
      <dl>
        {storyData.map(x => {
          if (x.text.length > 0) {
            index++;
            return (
              <div key={`storyItem${index.toString()}`}>
                <dt>{x.key} - {x.emotion}</dt>
                <dd>{x.text}</dd>
              </div>
            );
          }
          return <div key={`empty-${index}`}></div>;
        })}
      </dl>
    </div>
  );
  return ReactDOMServer.renderToStaticMarkup(results);
}

const CustomToolbar = ({
  toolBarCallback,
  disabled,
  headerContext,
  values,
  isSubmitting,
  storySelectedObj,
  getFullBook,
  hideStoryDropdown = false,
  preSelectedStory = null,
  preSelectedBook = null
}) => {
  const dispatch = useDispatch();
  const { submitForm, setFieldValue } = useFormikContext(); // Access Formik's submitForm and setFieldValue
  const { title, thumbnail, contentUrl, enabled, selectedStory, activeStoryObj } = values || {};
  const userProfile = useSelector(state => state.user.profile);
  const bookListOptions = useSelector(selectBookListOptions);
  const hasFullBook = useSelector(selectFullBookTreeData);
  const clearStory = useSelector(selectClearStory);

  // State for dropdown management
  const [artListDropdownOpen, setArtListDropdownOpen] = useState(false);

  // Field change handler for selectedStory
  const previousValuesRef = useRef(values);
  useEffect(() => {
    const handleFieldChange = () => {
      const currentValues = values;
      const previousValues = previousValuesRef.current;

      if (currentValues.selectedStory !== previousValues.selectedStory) {
        const current = currentValues.selectedStory;
        const previous = previousValues.selectedStory;

        let prevStory = storySelectedObj.current?.data?.uuid || "";
        let foundStoryOption = _.find(bookListOptions, (x) => x.value === current);

        setFieldValue('activeStoryObj', foundStoryOption);
        storySelectedObj.current = foundStoryOption;
        console.log(`selectedStory changed from "${previous}" to "${current}"`);

        if (storySelectedObj.current && storySelectedObj.current.data && prevStory !== storySelectedObj.current.data.uuid) {
          dispatch(fetchUserAndBookStatistics(storySelectedObj.current.data.uuid)).unwrap();
          getFullBook(storySelectedObj.current.data.uuid);
        }
      }

      previousValuesRef.current = currentValues;
    };

    handleFieldChange();
  }, [values, bookListOptions, dispatch, storySelectedObj, getFullBook, setFieldValue]);

  // Dropdown handlers
  const handleBookDDOpen = () => setArtListDropdownOpen(true);
  const handleBookDDClose = () => setArtListDropdownOpen(false);
  const [thumbnailFileName, setThumbnailFileName] = useState(null);

  const [bookPdfFileUrl, setBookPdfFileUrl] = useState(null);
  const [bookPdfFilename, setBookPdfFileName] = useState(null);
  const [ingestBookImgUrl, setIngestBookImgUrl] = useState(null)
  const [parsedStoryData, setParsedStoryData] = useState([]);

  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [submitPopupOpen, setSubmitPopupOpen] = useState(false);
  const [versionPopupOpen, setVersionPopupOpen] = useState(false);
  const [showProcessing, setShowProcessing] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const parsedStoryDataFetched = useSelector(selectParsedStoryData);
  const fetchparseDataFromS3Status = useSelector(selectFetchparseDataFromS3Status);
  const fetchparseDataFromS3Error = useSelector(selectFetchparseDataFromS3Error);
  const recentMsg = useRef('');

  const handleClear = () => {
    // Clear local state (existing code)
    setThumbnailUrl(null)
    setIsPopupOpen(false)
    setBookPdfFileUrl(null)
    setBookPdfFileName(null)
    setIngestBookImgUrl(null)
    setParsedStoryData([])
    setThumbnailFileName(null)
    setShowProcessing(false)
    setIsProcessing(false)

    // Reset Formik form fields that ProcessingStatusHint depends on
    setFieldValue('selectedStory', '');
    setFieldValue('title', '');
    setFieldValue('thumbnail', null);
    setFieldValue('pdfFile', null);
    setFieldValue('contentUrl', './shadowResponse.pdf');
    setFieldValue('storyFileName', '');
    setFieldValue('enabled', true);
    setFieldValue('activeStoryObj', null);

    toolBarCallback("./shadowResponse.pdf");
  };

  // const isConnected = useSelector((state) => state.sse.isConnected);
  const recentMessage = useSelector((state) => state.user.sse.recentMessage);
  const messages = useSelector((state) => state.user.sse.messages);

  // useEffect(() => {
  //   console.log(`SSE Connection Status: ${isConnected ? 'Connected' : 'Disconnected'}`);
  // }, [isConnected]); // This will run every time isConnected changes

  useEffect(() => {
    if (recentMessage.data !== undefined) {
      console.log('New message received:', recentMessage.data.message, 'chunk', recentMessage.data.index);
      if (recentMessage.data.index === undefined) {
        recentMsg.current = "Processing .pdf file..."
      }
      else {
        recentMsg.current = 'Processing group ' + recentMessage.data.index;
      }
    }
    else {
      recentMsg.current = "";
    }
  }, [recentMessage, messages]); // This will run every time a new message is added


  // useEffect(() => {
  //   console.log('formik values', values)
  // }, [values])

  useEffect(() => {
    if (hasFullBook && bookPdfFilename && userProfile?.data?.userId) {

      let jsonFile = bookPdfFilename.replace(/\.pdf$/, '.json');
      console.log('bookPdfFileUrl to json', jsonFile, 'hasFullBook', hasFullBook)
      dispatch(fetchparseDataFromS3({ userId: userProfile.data.userId, targetUrl: `${hasFullBook.bookTree.uuid}/book-process-items/${jsonFile}` }));

    }
  }, [dispatch, bookPdfFilename, hasFullBook, userProfile]);


  useEffect(() => {
    if (fetchparseDataFromS3Status === 'succeeded') {
      setParsedStoryData(parsedStoryDataFetched || []);
    } else if (fetchparseDataFromS3Status === 'failed') {
      setParsedStoryData(null);
    }
  }, [fetchparseDataFromS3Status, parsedStoryDataFetched, fetchparseDataFromS3Error, setParsedStoryData]);

  useEffect(() => {
    handleClear();
    console.log('CustomToolbar clearStory')
  }, [clearStory])

  const onVersionHandler = (item) => {
    console.log('Version Item', item)
    formatStoryDataJSON_HTML(parsedStoryData);
  }
  const formatStoryDataJSON = (storyData) => {
    // Handle both direct array and nested object structure
    let dialogueArray = storyData;

    // If it's the full object structure, extract the dialogue array
    if (storyData && typeof storyData === 'object' && !Array.isArray(storyData)) {
      if (storyData.dnObj && storyData.dnObj.dialogueArray) {
        dialogueArray = storyData.dnObj.dialogueArray;
      }
    }

    // Handle empty/null/undefined cases or non-array data
    if (_.isEmpty(dialogueArray) || !Array.isArray(dialogueArray)) {
      return (<div>No Story Data Object File(json) Found</div>)
    }

    let index = -1;
    let formattedStoryData = (<div style={{ height: "500px", overflowY: "scroll" }}>
      <dl >
        {
          dialogueArray.map(x => {
            if (x.text && x.text.length > 0) {
              index++;
              return (<div key={`storyItem${index.toString()}`} ><dt>{x.key} - {x.emotion}</dt><dd>{x.text}</dd></div>)
            }
            return null;
          })
        }
      </dl></div>)

    return formattedStoryData;
  }

  const enableSubmit = () => {
    if (!_.isEmpty(thumbnail) &&
      (!_.isEmpty(contentUrl) && contentUrl !== "./shadowResponse.pdf") &&
      title !== '') {
      return true;
    }
    return false;
  }

  const enableClearAll = () => {
    if (!_.isEmpty(thumbnail) ||
      !_.isEmpty(contentUrl) ||
      title !== '') {
      return true;
    }
    return false;
  }
  let displayProcessing = showProcessing && enableSubmit();
  const FilenameHelper = () => {
    return (
      <dl className="custom-toolbar-filename-helper">
        <dt>Story:</dt>
        <dd>{preSelectedBook?.name || <span>*Story required...</span>}</dd>

        <dt>Title:</dt>
        <dd>{title || <span>*Title required...</span>}</dd>

        <dt>Book cover:</dt>
        <dd>{thumbnailFileName || <span>*Book Cover not selected...</span>}</dd>

        <dt>Story pdf:</dt>
        <dd>{bookPdfFilename || <span>*Book .pdf file not selected...</span>}</dd>
      </dl>
    )
  }

  const SubmitHelper = () => {
    return (
      <div className="custom-toolbar-submit-container">
        <Popup
          trigger={
            <Button
              disabled={!enableSubmit() || isSubmitting || isProcessing}
              color='blue'
              style={{ width: "100%" }}
            >
              {isSubmitting ? 'Processing...' : 'Submit'}
            </Button>
          }
          on='click'
          position='top center'
          open={submitPopupOpen}
          onOpen={() => setSubmitPopupOpen(true)}
          onClose={() => setSubmitPopupOpen(false)}
          header={"Confirm Story Import"}
          content={
            <>
              <p>Are you sure you want to submit? This can be an extended time process.</p>
              <p className="custom-toolbar_confirm_hint">Please do not navigate away from this page or close the app while processing...</p>
              <div style={{ marginTop: '10px' }}>
                <Button color='red' onClick={() => setSubmitPopupOpen(false)}>No</Button>
                <Button color='green' onClick={() => {
                  submitForm();
                  setShowProcessing(true);
                  setSubmitPopupOpen(false);
                  setIsProcessing(true);
                }}>Yes</Button>
              </div>
            </>
          }
        />
      </div>
    )
  }

  return (
    <div style={{
      pointerEvents: disabled ? 'none' : 'auto',
      opacity: disabled ? 0.5 : 1,
    }}>

      {/* Processing Status Message */}
      {(isSubmitting || isProcessing) && (
        <div className="custom-toolbar-processing-status">
          <p className="custom-toolbar_confirm_hint">Please do not navigate away from this page or close the app while processing...</p>
          <span style={{ color: "#065c94", fontWeight: 'bold' }}>{recentMsg.current}</span>
        </div>
      )}

      {/* Top Row: Story Selection + Title + Enable + Helper Options */}
      <div className='custom-toolbar_story_selection_container' >
        <div className="custom-toolbar-form-group-gap">
          {!hideStoryDropdown ? (
            <div className="custom-toolbar-form-group">
              <Label className='custom-toolbar-label form-label'>Story:</Label>
              <Field
                name="selectedStory"
                component={CustomDropdown}
                options={bookListOptions}
                className={artListDropdownOpen ? 'no-radius-dropdown-open' : 'no-radius-dropdown'}
                onOpen={handleBookDDOpen}
                onClose={handleBookDDClose}
                placeholder='Select Story'
                selection
                style={{ zIndex: "10000", minWidth: '200px' }}
              />
            </div>
          ) : (
            <div className="custom-toolbar-form-group">
              <Label className='custom-toolbar-label form-label'>Story:</Label>
              <div style={{
                padding: '8px 14px',
                background: '#f8f8f8',
                border: '1px solid rgba(34,36,38,.15)',
                borderRadius: '4px',
                minWidth: '200px',
                display: 'inline-block'
              }}>
                {preSelectedBook?.name || 'No story selected'}
              </div>
            </div>
          )}

          <div className="custom-toolbar-form-group">
            <Label className='custom-toolbar-label form-label'>Title*:</Label>
            <Field name="title">
              {({ field }) => (
                <input
                  {...field}
                  type="text"
                  placeholder="Enter Story Title"
                  className="custom-toolbar-input-field"
                  disabled={(!activeStoryObj || !activeStoryObj.data) && !hideStoryDropdown}
                />
              )}
            </Field>
          </div>

          <div className="custom-toolbar-form-group">
            <Label className='custom-toolbar-label form-label'>Enable:</Label>
            <Field name="enabled">
              {({ field }) => (
                <Checkbox
                  style={{ paddingLeft: "8px" }}
                  checked={field.value}
                  onChange={(e, { checked }) => setFieldValue('enabled', checked)}
                />
              )}
            </Field>
          </div>
        </div>

        {/* Helper Options on the right */}
        <div className="custom-toolbar-helper-options">
          <Popup
            position={"top left"}
            offset={[-5, -8]}
            on="hover"
            content="Show Story Properties"
            trigger={
              <Popup
                position={"bottom left"}
                offset={[-5, 0]}
                on="click"
                content={<PDFMetadataViewer pdfUrl={bookPdfFileUrl} />}
                trigger={
                  <Image src={processedFileIcon} className="custom-toolbar-icon-button" style={{ width: "28px", height: "28px" }} />
                }
              />
            }
          />

          <Popup
            position={"top left"}
            on="click"
            onOpen={() => setVersionPopupOpen(true)}
            onClose={() => setVersionPopupOpen(false)}
            content={
              <div style={{ height: "auto", width: "700px", border: "none", padding: "10px" }}>
                <div style={{ color: "#000000" }}>
                  <FillVariations isOpen={versionPopupOpen} onVariationClick={onVersionHandler} />
                </div>
              </div>
            }
            trigger={
              <Image src={versionIcon} className="custom-toolbar-icon-button" style={{ width: "30px", height: "30px" }} />
            }
          />

          <Popup
            position={"bottom left"}
            offset={[-10, 0]}
            content={
              <div style={{ height: "auto", width: "360px", border: "none", padding: "10px" }}>
                <div style={{ color: "#000000", marginTop: "-25px" }}>
                  <ActiveStory />
                </div>
              </div>
            }
            trigger={
              <Image
                src={!_.isEmpty(hasFullBook) ? bookInfoIcon : bookInfoIconRed}
                className="custom-toolbar-icon-button"
                style={{ width: "20px", height: "20px" }}
              />
            }
          />

          {enableClearAll() && (
            <ConfirmButton title="Story Importer" handleClear={handleClear} />
          )}
        </div>
      </div>

      {/* Bottom Row: File Selectors + Processing + Submit */}
      <div className="custom-toolbar-bottom-row">

        {/* Book Cover Selector */}
        <div className="custom-toolbar-file-selector stdBoxShadow">
          <FileDropzoneOverImg
            onDropCallback={(file, url) => {
              setThumbnailUrl(url);
              setThumbnailFileName(file.name);
              setFieldValue('thumbnail', file);
            }}
            hintText={<div><span>Book Cover:</span><br /><span>Drag & drop or click</span></div>}
            altText={"Book Cover preview"}
            imgItem={thumbnailUrl}
          />
          {thumbnailFileName ? (
            <div className="custom-toolbar-filename-display">
              {thumbnailFileName}
            </div>
          ) : (<div className="custom-toolbar-filename-display">
            {"Select Book Cover"}
          </div>)}
        </div>

        {/* PDF File Selector */}
        <div className="custom-toolbar-file-selector stdBoxShadow">
          <FileDropzonePdf
            onDropCallback={(file, url) => {
              setBookPdfFileUrl(url);
              setBookPdfFileName(file.name);
              setIngestBookImgUrl(ingestBookImg);
              setFieldValue('contentUrl', url);
              setFieldValue('storyFileName', file.name);
              setFieldValue('pdfFile', file);
            }}
            hintText={<div><span>PDF File:</span><br /><span>Drag & drop or click</span></div>}
            altText={"Book PDF file selection"}
            imgItem={ingestBookImgUrl}
            showOverLay={false}
          />

          {bookPdfFilename ? (
            <div className="custom-toolbar-filename-display">
              {bookPdfFilename}
            </div>
          ) : (<div className="custom-toolbar-filename-display">
            {"Select Book File"}
          </div>)}

        </div>

        {/* Processing Indicator */}
        {(displayProcessing || isSubmitting) && (
          <div className="custom-toolbar-processing-indicator stdBoxShadow">
            <img
              src={processingIcon}
              alt="Processing"
              style={{ width: '100px', height: '87px' }}
            />
            <div className="custom-toolbar-filename-display">
              Processing Story
            </div>
          </div>
        )}

        {/* Processed Data Viewer */}
        {bookPdfFileUrl && !displayProcessing && !isSubmitting && (
          <div className="custom-toolbar-processed-data stdBoxShadow">
            <Popup
              position={"top left"}
              offset={[25, 20]}
              on="click"
              content={
                <div style={{ height: "auto", width: "500px", border: "none", padding: "10px" }}>
                  <div style={{ color: "#000000", marginTop: "-10px" }}>
                    <Header as='h3'>Story Data</Header>
                    <Header as='h5'>File: {bookPdfFilename}</Header>
                    {formatStoryDataJSON(parsedStoryData)}
                  </div>
                </div>
              }
              trigger={
                <Image
                  src={!_.isEmpty(ingestBookImgUrl) ? processedDataImgDone : processedDataImg}
                  // size='small'
                  className="custom-toolbar-icon-button"
                  style={{ width: '100px' }}
                />
              }
            />
            <div className="custom-toolbar-filename-display">
              Story to Process
            </div>
          </div>
        )}

        {/* Spacer to push Submit button to the right */}
        <div className="custom-toolbar-spacer"></div>

        {/* Submit Button */}
        <Grid style={{ maxWidth: "350px" }}>
          <Grid.Row style={{ paddingBottom: "0px" }}><Grid.Column><SubmitHelper /></Grid.Column></Grid.Row>
          <Grid.Row style={{ paddingTop: "0px" }}><Grid.Column><FilenameHelper /></Grid.Column></Grid.Row></Grid>

      </div>
    </div>
  );
};

export default CustomToolbar;
